import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export const AtlanCell = (props, labelKey = null, typeIdKey = null) => {

  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);


  return (
    <td>
      <button
        type="button"
        style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
        className="fw-bold text-decoration-underline"
        onClick={() => {
          navigate(
            `/data-catalog/details/${typeIdKey ? props.dataItem[typeIdKey] : props.dataItem.product_type_id}?${searchParams.toString()}`
          );
        }}
        tabIndex={0}
        aria-label={`View details for ${labelKey ? props.dataItem[labelKey] : props.dataItem.productName}`}
      >
        {labelKey ? props.dataItem[labelKey] : props.dataItem.productName}
      </button>
    </td>
  );
};

AtlanCell.propTypes = {
  dataItem: PropTypes.shape({
    product_type_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    productName: PropTypes.string.isRequired,
    typeHandle: PropTypes.string
  }).isRequired
};

export default AtlanCell;

